<template>
  <el-form
    ref="form"
    :rules="rules"
    :model="form"
    size="small"
  >
    <el-row>
      <el-col>
        <el-form-item
          label="Title"
          prop="title"
        >
          <el-input
            v-model="form.title"
            placeholder="Title"
            clearable
          />
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-form-item
          label="Date Range"
          prop="dateRange"
        >
          <el-select
            v-model="form.dateRange"
            placeholder="Please select a date range"
            class="w-100"
          >
            <el-option
              label="Week to Date"
              value="week"
            />
            <el-option
              label="Month to Date"
              value="month"
            />
            <el-option
              label="Year to Date"
              value="year"
            />
            <el-option
              label="Fixed Date Range"
              value="fixed"
            />
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row v-if="form.dateRange === 'fixed'">
      <el-col>
        <el-form-item
          label="Fixed Date Range"
          prop="fixedDateRange"
        >
          <el-date-picker
            v-model="form.fixedDateRange"
            type="daterange"
            format="dd/MM/yyyy"
            range-separator="To"
            start-placeholder="Start date"
            end-placeholder="End date"
            class="w-100"
          />
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-form-item
          label="Time Break Down"
          prop="timeBreakDown"
        >
          <el-select
            v-model="form.timeBreakDown"
            placeholder="Please select a time break down"
            clearable
            class="w-100"
          >
            <el-option
              label="By Day"
              value="Day"
            />
            <el-option
              label="By Week"
              value="Week"
            />
            <el-option
              label="By Month"
              value="Month"
            />
            <el-option
              label="By Year"
              value="Year"
            />
            <el-option
              label="By Date"
              value="Date"
            />
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
export default {
  props: {
    widget: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      form: {},
      rules: {
        title: [
          { required: true, message: 'Title of widget is required', trigger: 'blur' }
        ],
        dateRange: [
          { required: true, message: 'Date Range of widget is required', trigger: 'change' }
        ],
        fixedDateRange: [
          { required: true, message: 'Fixed Date Range of widget is required', trigger: 'change' }
        ]
      }
    }
  },
  created () {
    this.setWidgetToForm()
  },
  methods: {
    setWidgetToForm () {
      const identifier = Object.keys(this.widget)[0]
      const params = this.widget[identifier].configuration.params
      // Set Title
      this.$set(this.form, 'title', this.$_.get(this.widget[identifier].configuration, 'title', ''))
      // Set Time Break Down
      this.$set(this.form, 'timeBreakDown', this.$_.get(this.widget[identifier].configuration, 'timeBreakDown', ''))
      // Set DateRange
      if (params.dateFrom === 'week' || params.dateFrom === 'month' || params.dateFrom === 'year') {
        this.$set(this.form, 'dateRange', params.dateFrom)
      } else {
        this.$set(this.form, 'dateRange', 'fixed')
        this.$set(this.form, 'fixedDateRange', [])
        this.form.fixedDateRange.push(this.$moment(params.dateFrom))
        this.form.fixedDateRange.push(this.$moment(params.dateTo))
      }
    },
    submit () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const identifier = Object.keys(this.widget)[0]
          this.widget[identifier].configuration.title = this.form.title || ''
          this.widget[identifier].configuration.timeBreakDown = this.form.timeBreakDown || ''
          this.widget[identifier].configuration.params.dayBreakDown = this.form.timeBreakDown === 'Day'
          this.widget[identifier].configuration.params.weekBreakDown = this.form.timeBreakDown === 'Week'
          this.widget[identifier].configuration.params.monthBreakDown = this.form.timeBreakDown === 'Month'
          this.widget[identifier].configuration.params.yearBreakDown = this.form.timeBreakDown === 'Year'
          this.widget[identifier].configuration.params.dateFrom = this.form.dateRange === 'fixed' ? this.$moment(this.form.fixedDateRange[0]).format('YYYY-MM-DD') : this.form.dateRange
          this.widget[identifier].configuration.params.dateTo = this.form.dateRange === 'fixed' ? this.$moment(this.form.fixedDateRange[1]).format('YYYY-MM-DD') : 'today'
          this.$emit('submitted', this.widget)
        }
      })
    }
  }
}
</script>

<style>
</style>
